import { atom } from "recoil";

type TechnicalSupportModalState = {
  isOpen: boolean;
  isRequest?: boolean;
  isContactSales?: boolean;
  helpline?: boolean;
};

type BrokerSelectModalState = {
  isOpen: boolean;
  callback?: (id: string) => void;
};

type BrokerConnectModalState = {
  isOpen: boolean;
  brokerId?: string;
  default?: boolean;
};

export const brokerConnectModalAtom = atom<BrokerConnectModalState>({
  key: "brokerConnectModalAtom",
  default: {
    isOpen: false,
    brokerId: undefined,
  },
});

export const technicalSupportModalAtom = atom<TechnicalSupportModalState>({
  key: "technicalSupportModalAtom",
  default: {
    isOpen: false,
    isRequest: false,
    isContactSales: false,
    helpline: false,
  },
});

export const guideModalAtom = atom({
  key: "guideModalAtom",
  default: {
    isOpen: false,
    link: "",
  },
});

export const brokerSelectModalAtom = atom<BrokerSelectModalState>({
  key: "brokerSelectModalAtom",
  default: {
    isOpen: false,
    callback: undefined,
  },
});

export const assetLogos = atom<Record<string, string>>({
  key: "assetLogosAtom",
  default: {}, // empty map by default
});
